import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { keys } from "./keys";
import { enqueueSnackbar } from "../../../components/GlobalSnackbar/snackbarStore";

async function deleteProviderContact(contactId: string) {
  const { error } = await apiClient
    .from('provider_contacts')
    .delete()
    .eq('id', contactId);

  if (error) {
    throw error;
  }
}

type Variables = {
  providerId: string;
  contactId: string;
}

export default function useDeleteProviderContact() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ contactId }: Variables) => deleteProviderContact(contactId),
    onSuccess: (_, { providerId }) => {
      queryClient.invalidateQueries({ queryKey: keys.getProviderContacts(providerId) });
      enqueueSnackbar('Contact supprimé.', 'success');
    }
  });
}
